/* Evening Reset landing page (Porter Media). One small script for the page's own sections:
   the gallery, the mug offer and the cart, the accordions, the sticky bar and the scroll to the
   buy box. It defines no custom elements and loads no libraries, so it cannot collide with the
   theme's own code. Everything is wired again on shopify:section:load, so the theme editor
   keeps working after an edit. */
(function () {
  'use strict';
  if (window.lpEveningReset) return;
  window.lpEveningReset = true;

  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- the offer, read from the buy box ---------- */
  var offer = null;
  function readOffer() {
    var el = $('[data-lp-offer]');
    if (!el) { offer = null; return; }
    try { offer = JSON.parse(el.textContent); } catch (e) { offer = null; return; }
    // already worked out in the shopper's own market by the buy box
    offer.mugOffer = offer.mug ? offer.mug.offer : 0;
  }
  function fmt(cents, sample) {
    // Money in the same shape as a value the store has already formatted.
    sample = String(sample || (offer && offer.money.total) || '$0.00').replace(/<[^>]*>/g, '');
    var comma = /\d,\d{2}(\D*)$/.test(sample);
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    var num = parts.join(comma ? ',' : '.');
    return sample.replace(/\d[\d.,]*/, num);
  }
  function short(cents) { return fmt(cents).replace(/[.,]00(?!\d)/, ''); }

  /* ---------- state ---------- */
  var added = false, mugOn = false, busy = false, pendingMug = null, mugInCart = false;

  function paintMoney() {
    if (!offer) return;
    var total = offer.total + (mugOn ? offer.mugOffer : 0);
    $$('[data-lp-money="total"]').forEach(function (el) { el.textContent = fmt(total); });
    $$('[data-lp-money="set-short"]').forEach(function (el) { el.textContent = short(offer.total); });
    $$('[data-lp-money="night"]').forEach(function (el) {
      el.textContent = fmt(Math.round(offer.total / (offer.nights || 45)));
    });
    if (offer.mug) {
      $$('[data-lp-money="mug-offer"]').forEach(function (el) { el.textContent = fmt(offer.mugOffer); });
      $$('[data-lp-money="mug-save"]').forEach(function (el) {
        var price = offer.mug.price;
        el.textContent = short(Math.max(0, price - offer.mugOffer));
      });
    }
  }

  function paint() {
    $$('[data-lp-mug]').forEach(function (card) {
      var input = $('[data-lp-mug-input]', card);
      card.classList.toggle('is-locked', !added);
      card.classList.toggle('is-on', mugOn);
      card.classList.toggle('is-beat', added && !mugOn && !calm);
      if (input) { input.checked = mugOn; input.disabled = !added; }
      var more = $('[data-lp-mug-more]', card);
      if (more) more.hidden = !mugOn;
    });
    $$('[data-lp-atc]').forEach(function (b) {
      if (b.classList.contains('is-just')) return;
      var t = $('[data-lp-atc-text]', b);
      if (t && offer) t.textContent = added ? offer.text.checkout : offer.text.atc;
      b.setAttribute('aria-label', added ? offer.text.checkout : offer.text.atc);
      // Once the set is in, Checkout goes to an outline so the filled colour on the panel is
      // the mug offer. With the mug taken, Checkout is filled again: it is the next thing to press.
      b.classList.toggle('is-outline', added && !mugOn);
    });
    paintMoney();
  }

  // Tease's cart is Rebuy Smart Cart, which watches every cart request and slides its drawer
  // open. On this page the add is followed by the mug offer in the buy box, so the drawer stays
  // shut while our own requests run; the items still land in the same Rebuy cart, which is what
  // the shopper sees from the cart icon and at checkout.
  function quietCart(run) {
    var sc = window.Rebuy && Rebuy.SmartCart, show = sc && sc.show;
    if (show) { sc.lpShow = show; sc.show = function () {}; }
    var done = function () { setTimeout(function () { if (show) sc.show = show; }, 1500); };
    return run().then(function (r) { done(); return r; }, function (e) { done(); throw e; });
  }
  function cart(url, body) {
    return quietCart(function () { return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || r.status); });
      return r.json();
    }); });
  }
  function root() { return window.Shopify && Shopify.routes && Shopify.routes.root || '/'; }
  function showError(on) { $$('[data-lp-error]').forEach(function (e) { e.hidden = !on; }); }

  function flyToButton(btn) {
    if (calm || !btn.animate) return;
    var pics = $$('[data-lp-slide] img').filter(function (i) {
      var r = i.getBoundingClientRect(), v = i.closest('[data-lp-view]');
      var q = v ? v.getBoundingClientRect() : r, cx = r.left + r.width / 2;
      return r.width > 40 && r.bottom > 0 && r.top < innerHeight && cx > q.left && cx < q.right;
    });
    var from = pics[0]; if (!from) return;
    var a = from.getBoundingClientRect(), b = btn.getBoundingClientRect();
    var side = Math.min(120, a.width * 0.4);
    var fly = document.createElement('img');
    fly.src = from.currentSrc || from.src; fly.alt = ''; fly.setAttribute('aria-hidden', 'true');
    fly.className = 'lp-er-fly';
    fly.style.cssText = 'width:' + side + 'px;height:' + side + 'px;left:' + (a.left + a.width / 2 - side / 2) +
      'px;top:' + (a.top + a.height / 2 - side / 2) + 'px';
    document.body.appendChild(fly);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    fly.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 60) + 'px) scale(.6)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.2 }
    ], { duration: 650, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = function () { fly.remove(); };
  }

  function addSet(btn) {
    if (!offer || busy) return;
    busy = true; showError(false);
    btn.classList.add('is-busy');
    getCart().then(function (c) {
      var h = holds(c);
      if (h.set) { mugOn = mugInCart = h.mug; return c; }
      return cart(root() + 'cart/add.js', { items: offer.tins.map(function (t) { return { id: t.id, quantity: 1 }; }) });
    })
      .then(function () {
        readCart();
        added = true; busy = false; btn.classList.remove('is-busy');
        if (wantCheckout) { wantCheckout = false; checkout(); return; }
        flyToButton(btn);
        var t = $('[data-lp-atc-text]', btn);
        btn.classList.add('is-just'); if (t) t.textContent = offer.text.added;
        setTimeout(function () { btn.classList.remove('is-just'); paint(); }, calm ? 0 : 900);
        $$('[data-lp-mug]').forEach(function (m) {
          if (calm) return;
          m.classList.remove('is-pulse'); void m.offsetWidth; m.classList.add('is-pulse');
          // once the two strong pulses end, drop back to the steady one
          m.addEventListener('animationend', function done(ev) {
            if (ev.animationName !== 'lp-er-pulse') return;
            m.classList.remove('is-pulse'); m.removeEventListener('animationend', done);
          });
        });
        paint();
        document.dispatchEvent(new CustomEvent('lp-er:added'));
      })
      .catch(function () { busy = false; btn.classList.remove('is-busy'); showError(true); paint(); });
  }

  function checkout() {
    var code = offer && offer.discount;
    $$('[data-lp-atc]').forEach(function (b) { b.classList.add('is-busy'); });
    window.location.assign(root() + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''));
  }

  // A tap while the last mug request is still running is remembered and applied after it, so a
  // quick on-off never leaves the cart and the switch disagreeing.
  function settleMug() {
    if (pendingMug !== null && pendingMug !== mugInCart) { var want = pendingMug; pendingMug = null; setMug(want); }
    else pendingMug = null;
  }
  function setMug(on) {
    if (!offer || !offer.mug) return;
    if (busy) { pendingMug = on; mugOn = on; paint(); return; }
    busy = true; showError(false); mugOn = on; paint();
    var call = on
      ? cart(root() + 'cart/add.js', { items: [{ id: offer.mug.id, quantity: 1 }] })
      : cart(root() + 'cart/change.js', { id: String(offer.mug.id), quantity: 0 });
    call.then(function () { busy = false; mugInCart = on; paint(); readCart(); settleMug(); })
      .catch(function () { busy = false; mugOn = mugInCart; showError(true); paint(); settleMug(); });
  }

  // The page always opens on Add To Cart, whatever is already in the cart (Allan, 26/09/2026). What
  // the cart holds is read so the header count is right, and so Add To Cart never puts a second set
  // in: with the set already there, pressing it just moves on to Checkout and the mug offer.
  function getCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function holds(c) {
    var ids = c.items.map(function (i) { return i.variant_id; });
    return {
      set: !!offer && offer.tins.length > 0 && offer.tins.every(function (t) { return ids.indexOf(t.id) > -1; }),
      mug: !!(offer && offer.mug) && ids.indexOf(offer.mug.id) > -1
    };
  }
  function paintCount(c) {
    $$('[data-lp-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
  }
  function readCart() { getCart().then(paintCount).catch(function () {}); }

  /* ---------- scroll to the buy box ---------- */
  function jump(e) {
    var box = $('#lp-er-buy');
    if (!box) return;
    e.preventDefault();
    box.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
    // A long smooth scroll can stop short when something on the way changes height (a picture
    // finishing its download). Once it settles, land exactly on the buy box.
    var last = null, tries = 0;
    (function settle() {
      var top = Math.round(box.getBoundingClientRect().top);
      if (top === last || ++tries > 30) {
        if (Math.abs(top) > 2) box.scrollIntoView({ behavior: 'auto', block: 'start' });
        return;
      }
      last = top; setTimeout(settle, 120);
    })();
  }

  document.addEventListener('click', function (e) {
    var j = e.target.closest('[data-lp-jump]');
    if (j) { jump(e); return; }
  });
  // The buy button is handled first and alone (capture phase, nothing after it), so no other
  // script on the store (the Rebuy cart watches clicks on anything that says checkout) can turn
  // Checkout into something else. A press while the add is still running goes to checkout as
  // soon as it lands.
  var wantCheckout = false;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lp-atc]');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (a.disabled) return;
    if (added) { checkout(); return; }
    if (busy) { wantCheckout = true; return; }
    addSet(a);
  }, true);
  function openCart(e) {
    var sc = window.Rebuy && Rebuy.SmartCart;
    var show = sc && (sc.lpShow || sc.show);
    if (!show) return;              // no slide-out cart: the link goes to the cart page
    e.preventDefault();
    show.call(sc);
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-lp-cart]');
    if (c) openCart(e);
  }, true);
  // Changes made inside the drawer (an item removed, a quantity changed) flow back into the page.
  ['rebuy:cart.change', 'rebuy:smartcart.line-item-removed', 'rebuy:smartcart.hide'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      getCart().then(function (c) {
        paintCount(c);
        var h = holds(c);
        mugInCart = h.mug;
        if (added && !h.set) { added = false; mugOn = false; }
        else if (added && !busy) { mugOn = h.mug; }
        paint();
      }).catch(function () {});
    });
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-lp-mug-input]')) return;
    if (!added) { e.target.checked = false; return; }
    setMug(e.target.checked);
  });

  /* ---------- gallery ---------- */
  function gallery(g) {
    if (g.lpOn) return; g.lpOn = true;
    var track = $('[data-lp-track]', g), view = $('[data-lp-view]', g);
    var slides = $$('[data-lp-slide]', g), thumbs = $$('[data-lp-thumb]', g), rail = $('[data-lp-rail]', g);
    var frame = $('.lp-er-gal__frame', g);
    var n = slides.length, at = 0;
    if (!n || !track) return;

    // Fit the thumbnails across the width of the picture above them, 64px at most and 34px at
    // least, so every slide has a visible thumbnail rather than a rail that scrolls.
    function fitRail() {
      if (!rail || !thumbs.length) return;
      var w = Math.round(view.getBoundingClientRect().width);
      if (!w) return;
      var gap = 8, k = thumbs.length;
      var size = Math.floor((w - gap * (k - 1)) / k);
      if (size < 48) { gap = 4; size = Math.floor((w - gap * (k - 1)) / k); }
      size = Math.max(34, Math.min(64, size));
      rail.style.gap = gap + 'px';
      thumbs.forEach(function (t) { t.style.width = size + 'px'; t.style.height = size + 'px'; });
    }
    fitRail();
    addEventListener('resize', fitRail);
    if (window.ResizeObserver) new ResizeObserver(fitRail).observe(view);

    function show(i, human) {
      at = (i + n) % n;
      if (human) g.classList.add('is-still');  // the first picture's float stops once moved
      track.style.transform = 'translate3d(' + (-at * 100) + '%,0,0)';
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === at ? 'true' : 'false'); });
      // Never scrollIntoView here: it would scroll the whole page to reach the rail.
      if (human && rail && rail.scrollWidth > rail.clientWidth + 1 && thumbs[at]) {
        var t = thumbs[at];
        rail.scrollTo({ left: Math.max(0, t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function (e) { e.preventDefault(); show(k, true); }); });
    $$('[data-lp-arrow]', g).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); show(at + (b.getAttribute('data-lp-arrow') === 'next' ? 1 : -1), true);
      });
    });

    // Swipe. The picture follows the finger; letting go past a sixth of its width moves one
    // slide. A gesture that starts more up-down than sideways is left to scroll the page.
    // A finger goes through touch events (a non-passive touchmove lets iPhone Safari hand the
    // swipe over); a mouse drag goes through pointer events.
    var x0 = 0, y0 = 0, dx = 0, mode = null, pid = null;
    $$('img', track).forEach(function (im) { im.setAttribute('draggable', 'false'); });
    function begin(x, y) { x0 = x; y0 = y; dx = 0; mode = null; }
    function move(x, y) {
      var mx = x - x0, my = y - y0;
      if (mode === null) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return false;
        mode = Math.abs(mx) > Math.abs(my) ? 'swipe' : 'scroll';
        if (mode === 'scroll') return false;
        track.style.transition = 'none';
      }
      if (mode !== 'swipe') return false;
      dx = mx;
      track.style.transform = 'translate3d(calc(' + (-at * 100) + '% + ' + dx + 'px),0,0)';
      return true;
    }
    function end() {
      if (mode !== 'swipe') { mode = null; return; }
      track.style.transition = '';
      var w = view.getBoundingClientRect().width || 1;
      if (Math.abs(dx) > w / 6) show(at + (dx < 0 ? 1 : -1), true); else show(at, false);
      mode = null; dx = 0;
      // a drag is not a click on whatever sat under the pointer; the guard lapses on its own
      function stop(ev) { ev.preventDefault(); ev.stopPropagation(); }
      view.addEventListener('click', stop, { capture: true, once: true });
      setTimeout(function () { view.removeEventListener('click', stop, { capture: true }); }, 400);
    }
    view.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { mode = 'scroll'; return; }
      begin(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    view.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1 || mode === 'scroll') return;
      if (move(e.touches[0].clientX, e.touches[0].clientY) && e.cancelable) e.preventDefault();
    }, { passive: false });
    view.addEventListener('touchend', end);
    view.addEventListener('touchcancel', end);
    view.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || (e.pointerType === 'mouse' && e.button !== 0)) return;
      pid = e.pointerId; begin(e.clientX, e.clientY);
    });
    view.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch' || e.pointerId !== pid || mode === 'scroll') return;
      var was = mode;
      if (move(e.clientX, e.clientY) && was === null) { try { view.setPointerCapture(pid); } catch (err) {} }
    });
    function release(e) { if (e.pointerType === 'touch' || e.pointerId !== pid) return; pid = null; end(); }
    view.addEventListener('pointerup', release);
    view.addEventListener('pointercancel', release);
    // Trackpad: a sideways two-finger swipe moves one picture (one per gesture); up-down still
    // scrolls the page (Allan, 29/09/2026).
    var wx = 0, wLock = false, wTimer = null;
    view.addEventListener('wheel', function (e) {
      if (e.ctrlKey || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      clearTimeout(wTimer); wTimer = setTimeout(function () { wx = 0; wLock = false; }, 220);
      if (wLock) return;
      wx += e.deltaX;
      if (Math.abs(wx) > 40) { show(at + (wx > 0 ? 1 : -1), true); wLock = true; wx = 0; }
    }, { passive: false });
    show(0, false);
    // Once the page has loaded, fetch the rest of the gallery, so a tap on an arrow or a
    // thumbnail never shows an empty frame while its picture downloads.
    var warm = function () { $$('img[loading="lazy"]', track).forEach(function (im) { im.loading = 'eager'; }); };
    if (document.readyState === 'complete') setTimeout(warm, 1200); else addEventListener('load', function () { setTimeout(warm, 1200); });
  }

  /* ---------- accordions: one panel open at a time in each group ---------- */
  function accordion(group) {
    if (group.lpOn) return; group.lpOn = true;
    var items = $$('[data-lp-acc-btn]', group).map(function (b) {
      return { b: b, p: document.getElementById(b.getAttribute('aria-controls')) };
    }).filter(function (i) { return i.p; });
    function shut(it) {
      if (it.b.getAttribute('aria-expanded') !== 'true') return;
      it.b.setAttribute('aria-expanded', 'false');
      it.p.style.height = it.p.scrollHeight + 'px';
      void it.p.offsetHeight;
      it.p.style.height = '0px';
    }
    function open(it) {
      it.b.setAttribute('aria-expanded', 'true');
      it.p.style.height = it.p.scrollHeight + 'px';
      setTimeout(function () { if (it.b.getAttribute('aria-expanded') === 'true') it.p.style.height = 'auto'; }, calm ? 0 : 280);
    }
    items.forEach(function (it) {
      it.b.addEventListener('click', function (e) {
        e.preventDefault();
        var was = it.b.getAttribute('aria-expanded') === 'true';
        items.forEach(shut);
        if (!was) open(it);
      });
    });
  }

  /* ---------- ingredient tabs: one blend at a time ---------- */
  function tabs(group) {
    if (group.lpOn) return; group.lpOn = true;
    var btns = $$('[data-lp-tab]', group);
    function pick(t) {
      btns.forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); o.tabIndex = o === t ? 0 : -1; });
      $$('[data-lp-tabpanel]', group).forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
      // the panel around the tabs is open with a fixed height while it animates; let it follow
      var panel = group.closest('[data-lp-acc-panel]');
      if (panel && panel.style.height && panel.style.height !== '0px') panel.style.height = 'auto';
    }
    btns.forEach(function (t, k) {
      t.tabIndex = k === 0 ? 0 : -1;
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return; e.preventDefault();
        var n = btns[(k + d + btns.length) % btns.length]; n.focus(); pick(n);
      });
    });
  }

  /* ---------- sticky bar: shown only once the buy box is behind the shopper ---------- */
  function syncBar() {
    var box = $('#lp-er-buy');
    var past = box ? box.getBoundingClientRect().bottom <= 0 : window.scrollY > 600;
    document.documentElement.classList.toggle('lp-er-bar-on', past);
  }

  function play(v) { v.muted = true; var go = v.play && v.play(); if (go && go.catch) go.catch(function () {}); }
  // Small looping videos (the mug) start at once. The customer videos are a megabyte each, so
  // they load only when about to come on screen, and pause again once scrolled away.
  var seen = window.IntersectionObserver && new IntersectionObserver(function (list) {
    list.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) {
        if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; v.preload = 'auto'; }
        play(v);
      } else if (!v.paused) { v.pause(); }
    });
  }, { rootMargin: '300px 0px' });
  function kickVideos(scope) {
    $$('.lp-er video', scope).forEach(function (v) {
      if (v.hasAttribute('data-lp-lazy-video')) {
        if (seen) seen.observe(v);
        else { if (v.dataset.src) v.src = v.dataset.src; play(v); }
      } else { play(v); }
    });
  }

  function init(scope) {
    readOffer();
    $$('[data-lp-gallery]', scope).forEach(gallery);
    $$('[data-lp-acc]', scope).forEach(accordion);
    $$('[data-lp-tabs]', scope).forEach(tabs);
    kickVideos(scope);
    paint();
    syncBar();
  }

  // Once the first screen is done, fetch every other picture on the page in the background: the
  // panels, the other ingredient tabs, the gallery and everything further down. A shopper who
  // opens a panel or scrolls then finds the picture already there instead of watching it arrive
  // (Allan, 26/09/2026). It waits for the page to finish loading, so the first screen is never slower.
  function warmAll() {
    var go = function () {
      $$('.lp-er img[loading="lazy"]').forEach(function (im, k) {
        setTimeout(function () { im.loading = 'eager'; }, k * 40);
      });
    };
    if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 800);
  }
  if (document.readyState === 'complete') warmAll(); else addEventListener('load', warmAll);

  // Pictures further down start loading about two screens before they reach the screen, from the
  // moment the page is readable. The warm-up above waits for Tease's apps to finish (about 7s on a
  // phone), so a shopper who scrolls straight away used to meet blank boxes (Allan, 29/09/2026).
  function aheadOfScroll() {
    if (!window.IntersectionObserver) return;
    var io = new IntersectionObserver(function (list) {
      list.forEach(function (en) { if (en.isIntersecting) { en.target.loading = 'eager'; io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px 1600px 0px' });
    $$('.lp-er img[loading="lazy"]').forEach(function (im) { io.observe(im); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aheadOfScroll); else aheadOfScroll();

  addEventListener('scroll', syncBar, { passive: true });
  addEventListener('resize', syncBar);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); readCart(); });
  } else { init(document); readCart(); }
})();
